var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtmosSymbolInvert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 786.883,
    height: 630,
    viewBox: "0 0 786.883 630",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atmos-logo-invert-square",
    transform: "translate(-140.207 -224.73)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    cx: 315,
    cy: 315,
    r: 315,
    transform: "translate(297.09 224.73)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2789",
    "data-name": "Path 2789",
    d: "M148.96,831.61c20.25,0,43.4-14.92,57.86-47.64L327.75,470.03c3.47-9.18,13.89-12.05,23.72-12.05a36.1,36.1,0,0,1,8.1.57L487.43,789.71c14.46,32.71,27.77,41.32,50.92,41.9,10.42,0,10.41,12.05,5.78,16.07H384.44c-4.63-4.02-4.63-16.08,5.79-16.08,21.41,0,44.55-2.87,31.82-36.73l-28.93-73.46H261.78l-21.41,62.55c-9.26,26.4,1.16,47.64,34.71,47.64h2.89c10.42-.57,10.41,12.05,5.79,16.07H143.17c-4.63-4.02-4.63-16.08,5.79-16.07ZM269.31,699.03H385.03L323.12,541.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2790",
    "data-name": "Path 2790",
    d: "M719.81,506.35c24.63-44.53,36.38-77.25,39.84-87.68a2.39,2.39,0,0,0-2.61-3.12c-19.41,2.69-108.05,21.72-116.9,145.57a3.745,3.745,0,0,0,3.95,3.24,9.663,9.663,0,0,0,3.7-.89h0s42.99-4.64,72.02-57.13Z",
    fill: "#eaf2ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2791",
    "data-name": "Path 2791",
    d: "M486.25,353.82a3.168,3.168,0,0,0-3.97,4.02c18.35,50.29,27.61,169.63,132.15,206.46h0L614,748.08l14.29.04.45-190.76c1.54-150.18-114.87-195.02-142.49-203.54Z",
    fill: "#eaf2ec"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmosSymbolInvert);
export default __webpack_public_path__ + "static/media/atmos-symbol-invert.14bb1abec86cd489d3fb5094021f1533.svg";
export { ForwardRef as ReactComponent };